import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AdminSocketProvider } from './context/AdminSocketContext';
import Login from './pages/login';
import AppLayout from './components/layout/AppLayout';
import Home from './pages/home';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen dark:bg-dark_bg_1 flex items-center justify-center">
        <p className="text-dark_text_2">جاري التحميل...</p>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  useEffect(() => {
    document.documentElement.lang = 'ar';
    document.documentElement.dir = 'rtl';
    document.documentElement.classList.add('dark');
    document.body.classList.add('dark');
  }, []);

  return (
    <div className="dark" >
      <Router>
        <AuthProvider>
          <AdminSocketProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/app"
                element={
                  <PrivateRoute>
                    <AppLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/app/dashboard" replace />} />
                <Route path="dashboard" element={<Home />} />
                <Route path="inbox" element={<Home />} />
                <Route path="inbox/:sessionId" element={<Home />} />
                <Route path="users" element={<Home />} />
                <Route path="platform-pages" element={<Home />} />
                <Route path="settings" element={<Home />} />
              </Route>
              <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
            </Routes>
          </AdminSocketProvider>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
